module.exports = {"data":{"markdownRemark":{"html":"<p>Our weekly Sunday worship service is held at the following location in the sanctuary at 12:00 pm.</p>\n<h3>Service Time</h3>\n<p>Sundays at 12:00 pm</p>\n<h3>Location</h3>\n<address>\n  10510 Stone Ave N<br />\n  Seattle, WA 98133\n</address>\n<p><a href=\"tel:+1(206) 240-9648\">(206) 240-9648</a></p>","frontmatter":{"title":"Come and Visit Us"}}},"pathContext":{"id":"/opt/build/repo/src/pages/location/index.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/location.json
// module id = 379
// module chunks = 108964885875472